module.exports = __webpack_public_path__ + "static/media/devopsIcon.f320f78b.png";